const SET_STEP = 'REGISTRATION_SET_STEP';
const EXPERIENCE_STEP = 'REGISTRATION_EXPERIENCE_STEP';
const MAILBOX_STEP = 'REGISTRATION_MAILBOX_STEP';
const LOGIN_REDIRECTION = 'LOGIN_REDIRECTION';
const SEND_ACTIVATION_EMAIL = 'REGISTRATION_SEND_ACTIVATION_EMAIL';
const SENT_ACTIVATION_EMAIL = 'REGISTRATION_SENT_ACTIVATION_EMAIL';
const SET_USER_ID = 'REGISTRATION_SET_USER_ID';

const setStep = (step) => ({
  type: SET_STEP,
  payload: {
    step
  }
});

const sendActivationEmail = (userId) => ({
  type: SEND_ACTIVATION_EMAIL,
  payload: {
    userId
  }
});

const sentActivationEmail = () => ({
  type: SENT_ACTIVATION_EMAIL
});

const setUserId = (userId) => ({
  type: SET_USER_ID,
  payload: {
    userId
  }
});

export {
  MAILBOX_STEP,
  EXPERIENCE_STEP,
  SEND_ACTIVATION_EMAIL,
  SENT_ACTIVATION_EMAIL,
  SET_USER_ID,
  LOGIN_REDIRECTION,
  setUserId,
  sendActivationEmail,
  sentActivationEmail,
  SET_STEP,
  setStep
};
